import { Header } from './components/Header'
import { Footer } from './components/Footer'
import { Hero } from './sections/Hero'
import { Problem } from './sections/Problem'
import { Concepts } from './sections/Concepts'
import { Features } from './sections/Features'
import { HowItWorks } from './sections/HowItWorks'
import { Examples } from './sections/Examples'
import { CTA } from './sections/CTA'

export function App() {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Header />
      <main className="flex-1">
        <Hero />
        <Problem />
        <Concepts />
        <Features />
        <HowItWorks />
        <Examples />
        <CTA />
      </main>
      <Footer />
    </div>
  )
}
